import matchesActiveState from 'src/util/activeState';
import { ACTIVE_STATE_ACTIVE, ACTIVE_STATE_INACTIVE, LIST_FILTER_ALL } from 'src/util/constants';

/**
 * Checks if the provided `portfolios` object has any edges.
 * @param {object} portfolios - The portfolios object to check.
 * @returns {boolean} `true` if the `portfolios` object has any edges, `false` otherwise.
 */
export const hasPortfolio = (portfolios) => !!(portfolios?.edges?.length > 0);

/**
 * Filters the portfolios based on the active filter.
 * @param {object} portfolios - The portfolios object containing the edges.
 * @param {ACTIVE_STATE_ACTIVE | ACTIVE_STATE_INACTIVE |LIST_FILTER_ALL} activeState
 * The active filter to apply.
 * @returns {Array<object>} - All portfolios or active portfolios.
 */
export const portfoliosWithActiveState = (portfolios, activeState) => portfolios?.edges?.filter(
  (edge) => matchesActiveState(edge.node, activeState),
);
